var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12910_105359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12910_105359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5898 22.0992C6.09452 22.0992 5.67188 21.923 5.32188 21.5705C4.97187 21.218 4.79688 20.7942 4.79688 20.2992V10.6992C4.79688 10.2042 4.97312 9.78047 5.32562 9.42797C5.67812 9.07547 6.10188 8.89922 6.59688 8.89922H7.19688V6.49922C7.19688 5.17122 7.66543 4.03922 8.60253 3.10322C9.53963 2.16722 10.673 1.69922 12.0025 1.69922C13.3321 1.69922 14.4635 2.16722 15.3969 3.10322C16.3302 4.03922 16.7969 5.17122 16.7969 6.49922V8.89922H17.3969C17.8919 8.89922 18.3156 9.07547 18.6681 9.42797C19.0206 9.78047 19.1969 10.2042 19.1969 10.6992V20.2992C19.1969 20.7942 19.0205 21.218 18.6678 21.5705C18.3151 21.923 17.8911 22.0992 17.3959 22.0992H6.5898ZM6.59688 20.2992H17.3969V10.6992H6.59688V20.2992ZM12.0022 17.2992C12.4986 17.2992 12.9219 17.1225 13.2719 16.7689C13.6219 16.4154 13.7969 15.9904 13.7969 15.4939C13.7969 14.9975 13.6201 14.5742 13.2666 14.2242C12.913 13.8742 12.488 13.6992 11.9916 13.6992C11.4951 13.6992 11.0719 13.876 10.7219 14.2295C10.3719 14.5831 10.1969 15.0081 10.1969 15.5045C10.1969 16.001 10.3736 16.4242 10.7272 16.7742C11.0807 17.1242 11.5057 17.2992 12.0022 17.2992ZM8.99688 8.89922H14.9969V6.49922C14.9969 5.66589 14.7052 4.95755 14.1219 4.37422C13.5385 3.79089 12.8302 3.49922 11.9969 3.49922C11.1635 3.49922 10.4552 3.79089 9.87188 4.37422C9.28854 4.95755 8.99688 5.66589 8.99688 6.49922V8.89922Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1d46114572f1109786443bd32b70bf38.svg";
export { ForwardRef as ReactComponent };